import React from 'react';
import styled from 'styled-components';
import ScrollIndicator from '../components/ScrollIndicator';
import VideoSection from '../components/VideoSection';
import PageLayout from '../components/PageLayout';

const HomeContainer = styled.div`
  min-height: 200vh;
  position: relative;
`;

const HeroSection = styled.section`
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
`;

const Home = () => {
  return (
    <PageLayout>
      <HomeContainer>
        <HeroSection>
          {/* Main title is already fixed position */}
          <ScrollIndicator />
        </HeroSection>
        
        <VideoSection />
      </HomeContainer>
    </PageLayout>
  );
};

export default Home;